module.exports = __webpack_public_path__ + "static/scale-model-of-bear-hollow-wildlife-trail-in-athens-georgia-7600a9323c5986e50f4ba1aeaef4c1de.png";